import { Component } from '@angular/core';

@Component({
  templateUrl: './symap.component.html',
})

export class SymapComponent {

}
